import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PRIMARY_OUTLET, Router, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';
import { globals } from '../../environments/globals';

@Injectable({
   providedIn: 'root'
})
export class SEOService { 
   mediaURL: string = environment.mediaURL;
   webURL: string = environment.webURL;
   countries: any[] = globals.countries.filter((site: { active: boolean; }) => site.active);
   image: string | undefined;
   service: string | undefined;
   classification: string | undefined;
   location: string | undefined;
   skill: string | undefined;
   country: any;
   type: string | undefined;
   sites: any[] | undefined;
   links: any[] | undefined;
   constructor(
      @Inject(DOCUMENT) private doc: Document,
      private router: Router
   ) {}

   createPreloadLinkForLCP() {
      let preload = false;
      if (this.router.url == '/') {
         this.image = 'gig-town';
         this.type = 'home';
         preload = true;
      } else {
         const tree: UrlTree = this.router.parseUrl(this.router.url);
         const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
         const s: UrlSegment[] = g.segments;
         if (s[3] && s[0].path == 'services') {
            // services/classification/skill/country
            this.service = s[0].path;
            this.classification = s[1].path;
            this.skill = s[2].path;
            this.country = s[3].path;
            this.image = this.skill + '-' + this.service + '-' + this.classification + '-country';
            this.type = 'content';
            preload = true;
         } else if (s[2] && s[0].path == 'services') {
            // services/classification/country
            this.service = s[0].path;
            this.classification = s[1].path;
            this.image = 'banner-' + this.service + '-' + this.classification + '-country';
            this.type = 'content';
            preload = true;
         } else if (s[2] && s[0].path == 'location') {
            // location/country/region
            this.country = s[1].path;
            this.location = s[2].path;
            this.image = this.location + '-' + this.country;
            this.type = 'location';
            preload = true;
         } else if (!s[2] && s[0].path == 'location') {
            // location/country
            this.country = s[1].path;
            this.image = this.country + '-' + this.country;
            this.type = 'location';
            preload = true;
         } else if (s[0].path == 'home') {
            // home/country 
            this.image = 'gig-town';
            this.type = 'home';
            preload = true;
         }   
      }
      if (preload) {
         const mobile = <HTMLLinkElement> this.doc.head.querySelector("link[title='mobile']");
         if(mobile) {
            mobile.as = "image";
            // console.log('mobile',mobile);
            if (this.type == 'content' || this.type == 'location') {
               mobile.href  = "/assets/images/banners/" + this.image + "-mobile.webp";
               mobile.media = "(max-width: 600px)";
            } else if (this.type == 'home') {
               mobile.href  = "/assets/images/" + this.image + "-mobile.webp";
               mobile.media = "(max-width: 991px)";
            }
         } else {
            // console.log('creating mobile');
            const newMobile = this.doc.createElement("link");
            newMobile.rel   = "preload";
            newMobile.as    = "image";
            newMobile.title = "mobile";
            if (this.type == 'content' || this.type == 'location') {
               newMobile.href  = "/assets/images/banners/" + this.image + "-mobile.webp";
               newMobile.media = "(max-width: 600px)";
            } else if (this.type == 'home') {
               newMobile.href  = "/assets/images/" + this.image + "-mobile.webp";
               newMobile.media = "(max-width: 991px)";
            }
            this.doc.head.appendChild(newMobile);
         }
         const tablet = <HTMLLinkElement> this.doc.head.querySelector("link[title='tablet']");
         if (tablet) {
            tablet.as = "image";
            // console.log('tablet',tablet);
            if (this.type == 'content' || this.type == 'location') {
               tablet.href  = "/assets/images/banners/" + this.image + "-tablet.webp";
               tablet.media = "(min-width: 600px) and (max-width: 1200px)";
            } else if (this.type == 'home') {
               tablet.href  = "/assets/images/" + this.image + "-retina.webp";
               tablet.media = "(min-width: 992px) and (max-width: 1200px)";
            }
         } else {
            // console.log('creating tablet');
            const newTablet = this.doc.createElement("link");
            newTablet.rel   = "preload";
            newTablet.as    = "image";
            newTablet.media = "(min-width: 600px) and (max-width: 1200px)";
            newTablet.title = "tablet";
            if (this.type == 'content' || this.type == 'location') {
               newTablet.href  = "/assets/images/banners/" + this.image + "-tablet.webp";
            } else if (this.type == 'home') {
               newTablet.href  = "/assets/images/" + this.image + "-retina.webp";
            }
            this.doc.head.appendChild(newTablet);
         }
         const desktop = <HTMLLinkElement> this.doc.head.querySelector("link[title='desktop']");
         if (desktop) {
            desktop.as = "image";
            // console.log('desktop',desktop);
            if (this.type == 'content' || this.type == 'location') {
               desktop.href  = "/assets/images/banners/" + this.image + ".webp";
            } else if (this.type == 'home') {
               desktop.href  = "/assets/images/" + this.image + "-retina.webp";
            }
         } else {
            // console.log('creating desktop');
            const newDesktop = this.doc.createElement("link");
            newDesktop.rel   = "preload";
            newDesktop.as    = "image";
            newDesktop.media = "(min-width: 1200px)";
            newDesktop.title = "desktop";
            if (this.type == 'content' || this.type == 'location') {
               newDesktop.href  = "/assets/images/banners/" + this.image + ".webp";
            } else if (this.type == 'home') {
               newDesktop.href  = "/assets/images/" + this.image + "-retina.webp";
            }
            this.doc.head.appendChild(newDesktop);
         }
      } else {
         const mobile = <HTMLLinkElement> this.doc.head.querySelector("link[title='mobile']");
         if (mobile) {
            this.doc.head.removeChild(mobile);
         }
         const tablet = <HTMLLinkElement> this.doc.head.querySelector("link[title='tablet']");
         if (tablet) {
            this.doc.head.removeChild(tablet);
         }
         const desktop = <HTMLLinkElement> this.doc.head.querySelector("link[title='desktop']");
         if (desktop) {
            this.doc.head.removeChild(desktop);
         }
      }
   }

   createLinkForCanonicalURL() {
      if (this.router.url == '/') {
      } else {
         const tree: UrlTree = this.router.parseUrl(this.router.url);
         const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
         const s: UrlSegment[] = g.segments;
         const link = <HTMLLinkElement> this.doc.head.querySelector("link[rel='canonical']")
         || this.doc.head.appendChild(this.doc.createElement("link"));
         link.rel = "canonical";
         const robots = <HTMLMetaElement> this.doc.head.querySelector("meta[name='robots']")
         // console.log('s',s);
         link.href = 'https://app.gigexchange.com' + this.doc.location.pathname;
      }
   }

   createAlternateURLs() {
      this.sites = this.countries.filter(site => site.active);
      this.links = this.sites.filter(site => {
         const lcode = 'en';
         const ccode = site.code.toLowerCase();
         const hreflang = ccode.length ? `${lcode}-${ccode}` : lcode;
         const base = this.doc.head.querySelector('base')?.getAttribute('href') || '';
         let path = this.doc.location.pathname;
         if (path.startsWith('/en-')) {
            path = path.split(/[\/]en-[a-z][a-z]/).pop()?.slice(1) || '';
         } else {
            path = path.replace(base, '');
         }
         if (hreflang) {
            const link = <HTMLLinkElement> this.doc.head.querySelector("link[hreflang='" + hreflang + "']")
            || this.doc.head.appendChild(this.doc.createElement("link"));
            link.rel = "alternate";
            link.href = this.doc.location.origin + '/' + hreflang + '/' + path;
            link.hreflang = hreflang;
            return site;
         }
      })
   }

   createLinkForXDefault() {
      const link = <HTMLLinkElement> this.doc.head.querySelector("link[hreflang='x-default']")
      || this.doc.head.appendChild(this.doc.createElement("link"));
      const base = this.doc.head.querySelector('base')?.getAttribute('href') || '';
      let path = this.doc.location.pathname;
      if (path.startsWith('/en-')) {
         path = path.split(/[\/]en-[a-z][a-z]/).pop()?.slice(1) || '';
      } else {
         path = path.replace(base, '');
      }
      link.rel = "alternate";
      link.href = this.doc.location.origin + '/en/' + path;
      link.hreflang = "x-default";
   }

   findNestedObj(entireObj: any, keyToFind: string, valToFind: string) {
      let foundObj: any;
      JSON.stringify(entireObj, (_, nestedValue) => {
        if (nestedValue && nestedValue[keyToFind] === valToFind) {
          foundObj = nestedValue;
        }
        return nestedValue;
      })
      return foundObj;
   }  
}